import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import HelpIcon from '@material-ui/icons/Help';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Tooltip from '@material-ui/core/Tooltip';

import PATH from 'routes/path';

import { Button } from 'components/Button';

import Logo from './Logo';

import {
  Header,
  StyledIcon,
  StyledMenu,
  Container,
  StyledMenuItem,
} from './styles';

// Menu externo
const Menu = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const history = useHistory();

  const goBack = () => history.push(PATH.LANDING);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Menu Mobile (com dropdown)
  const getMobileMenu = () => (
    <nav>
      <StyledIcon
        color="secondary"
        onClick={handleClick}
      >
        <MenuIcon size="small" />
      </StyledIcon>
      <StyledMenu
        keepMounted
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <StyledMenuItem onClick={handleClose}>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://ajuda.tikal.tech/pt-BR/collections/2748191-loit-fgts"
          >
            <Button
              variant="outlined"
              style={{ border: 0 }}
              endIcon={<HelpIcon />}
            >
              Central de ajuda
            </Button>
          </a>
        </StyledMenuItem>
        <StyledMenuItem onClick={handleClose}>
          <Link to={PATH.SIGNUP}>
            <Button
              variant="outlined"
              style={{ border: 0 }}
            >
              Cadastrar
            </Button>
          </Link>
        </StyledMenuItem>
        <StyledMenuItem onClick={handleClose}>
          <Link to={PATH.LOGIN}>
            <Button variant="contained">
              Entrar
            </Button>
          </Link>
        </StyledMenuItem>
      </StyledMenu>
    </nav>
  );

  return (
    <Header>
      <Container>
        <Tooltip title="Voltar" arrow>
          <IconButton
            onClick={goBack}
            color="secondary"
          >
            <ArrowBackIcon size="small" aria-label="Voltar" />
          </IconButton>
        </Tooltip>
        <Logo />
        {getMobileMenu()}
      </Container>
    </Header>
  );
};

export default Menu;
